import React from "react";
import { Field, reduxForm, useReduxForm } from "redux-form";
import { connect } from "react-redux";
import { required } from "redux-form-validators";
import { renderField, renderTextField, renderselect } from "../../../../Components/Forms/renders";
import AIEnhancedRichText from "../../../../Components/Forms/AIEnhancedRichText";
import UploadFrom from "../../../../Components/Forms/upload";
import DateSelect from "../../../../Components/Forms/date";

let BerichtenForm = (props) => {
  const { handleSubmit, change } = props;

  // Functie om de slug te genereren
  const createslug = (event, value) => {
    var slug = value
      .toString()
      .trim()
      .toLowerCase()
      .replace(/\s+/g, "-")
      .replace(/[^\w]+/g, "")
      .replace(/^-+/, "")
      .replace(/-+$/, "");
    change("post_name", slug);
  };

  // Functie om de slug te normaliseren
  const checkslug = (value) => {
    return value
      .toString()
      .replace(/ /g, "-")
      .trim()
      .toLowerCase()
      .replace(/\s+/g, "-")
      .replace(/[^\w]+/g, "-")
      .replace(/ /g, "-");
  };

  return (
    <div className="box box-default">
      <form onSubmit={handleSubmit}>
        <div className="box-body">
          <div className="row">
            <div className="col-12">
              <Field name="post_title" onChange={createslug} type="input" validate={[required()]} component={renderField} label="Titel Bericht" />
              <Field name="post_excerpt" type="input" component={renderTextField} label="Korte Samenvatting van het Bericht" />
              <Field name="post_content" component={AIEnhancedRichText} label="Bericht Inhoud" validate={[required()]} />
              <Field name="post_slug" normalize={checkslug} type="input" component={renderField} label="Slug (Korte Naam)" />
              <Field name="post_image" type="input" component={UploadFrom} label="Header foto bericht" />
              <Field name="post_author" type="input" component={renderField} label="Auteur" validate={[required()]} />
              <Field
                name="post_category"
                type="input"
                validate={[required()]}
                label="Categorie"
                component={renderselect}
                options={{
                  nieuws: "Nieuws",
                  casos: "Casos",
                  evenementen: "Evenementen",
                  aankondigingen: "Aankondigingen",
                  activiteiten: "Activiteiten"
                }}
              />
              <Field name="post_date" type="input" component={DateSelect} label="Datum publiceren" validate={[required()]} />
              <Field
                name="post_status"
                type="input"
                validate={required({ msg: "Dit item is verplicht" })}
                label="Bericht Status"
                component={renderselect}
                options={{
                  publish: "Publiceren",
                  draft: "Concept",
                  private: "Privé",
                  pending: "In afwachting",
                }}
              />
            </div>
          </div>
          <div className="pull-left submit">
            <input type="submit" className="btn btn-next btn-fill btn-success btn-wd btn-mg" name="next" value="Aanmaken" />
          </div>
        </div>
      </form>
    </div>
  );
};

BerichtenForm = reduxForm({
  form: "berichteninsert", // Een unieke identificatie voor dit formulier
})(BerichtenForm);

BerichtenForm = connect()(BerichtenForm);

export default BerichtenForm;
